import { useState } from 'react';
import { useSubmitFeedback, type FeedbackType } from '../hooks/useHatMail';

interface FeedbackPromptProps {
  responseId: string;
  onDismiss: () => void;
}

const OPTIONS: { value: FeedbackType; label: string }[] = [
  { value: 'tone', label: 'Tone' },
  { value: 'wrong_info', label: 'Wrong info' },
  { value: 'missing_detail', label: 'Missing detail' },
  { value: 'other', label: 'Other' },
];

export default function FeedbackPrompt({ responseId, onDismiss }: FeedbackPromptProps) {
  const [submitted, setSubmitted] = useState(false);
  const feedback = useSubmitFeedback();

  const handleSelect = (type: FeedbackType) => {
    feedback.mutate(
      { response_id: responseId, feedback_type: type },
      { onSuccess: () => setSubmitted(true) },
    );
    // Auto-dismiss after 1.5s
    setTimeout(onDismiss, 1500);
  };

  if (submitted) {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-700">
        Thanks — this helps the AI improve.
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2.5">
      <p className="mb-2 text-xs font-medium text-gray-500">What was off?</p>
      <div className="flex flex-wrap gap-1.5">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            onClick={() => handleSelect(opt.value)}
            disabled={feedback.isPending}
            className="rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 hover:border-ghw-gold hover:bg-ghw-cream active:bg-ghw-gold/20 transition-colors disabled:opacity-50"
            style={{ minHeight: '32px' }}
          >
            {opt.label}
          </button>
        ))}
        <button
          onClick={onDismiss}
          className="ml-auto text-xs text-gray-400 hover:text-gray-600"
        >
          Skip
        </button>
      </div>
    </div>
  );
}
